import styled from 'styled-components';
import First from '@assets/images/logo/incorrect/incorrect_1.svg'; 
import Second from '@assets/images/logo/incorrect/incorrect_2.svg'; 
import Third from '@assets/images/logo/incorrect/incorrect_3.svg'; 
import Fourth from '@assets/images/logo/incorrect/incorrect_4.svg'; 
import Five from '@assets/images/logo/incorrect/incorrect_5.svg'; 
import Six from '@assets/images/logo/incorrect/incorrect_6.svg'; 
import Seven from '@assets/images/logo/incorrect/incorrect_7.svg'; 
import Eight from '@assets/images/logo/incorrect/incorrect_8.svg'; 

export const FirstImg = styled(First)`
`;

export const SecondImg = styled(Second)`
`;

export const ThirdImg = styled(Third)`
`;

export const FourthImg = styled(Fourth)`
`;

export const FiveImg = styled(Five)`
`;

export const SixImg = styled(Six)`
`;

export const SevenImg = styled(Seven)`
`;

export const EightImg = styled(Eight)`
`;
